import { RootState } from "../../store/root-reducer";

const getState = (state: RootState) => state.waitingQueueSlots;

export const getWaitingQueueSlotIsValid = (state: RootState) => getState(state).slotIsValid;

export const getWaitingQueueSlot = (state: RootState) => getState(state).waitingQueueSlot;

export const getWaitingQueueSlotError = (state: RootState) => getState(state).error;
